import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

@Component({
  selector: 'app-edit-slider',
  templateUrl: './edit-slider.component.html',
  styleUrls: ['./edit-slider.component.scss']
})
export class EditSliderComponent implements OnInit, AfterViewInit {
  @Input() bannerInfo: any;
  fileImg64: any;
  urlImgLogo: string;
  wrongSize: any;
  bannerForm: FormGroup;
  reference: number;
  // flags
  isRentMax = false;
  isRent = false;

  // Dictionary to map ranges to dimensions
  imageDimensionsMap: { [key: string]: ImageDimensions } = {
    "1-10": { width: 1200, height: 800 },
    "fondos-e-inversion": { width: 1400, height: 400 },
    "rentas-vitalicias": { width: 1400, height: 400 },
  };
  dimensions: ImageDimensions;

  fileImg64Mobile: any;
  wrongSizeMobile: any;

  imageDimensionsMapMobile: { [key: string]: ImageDimensions } = {
    // "1-10": { width: 1200, height: 800 },
    "fondos-e-inversion": { width: 325, height: 380 },
    "rentas-vitalicias": { width: 325, height: 380 },
  };
  dimensionsMobile: ImageDimensions;
  maxLength: number;

  constructor(
    private fb: FormBuilder,
    private activeModal: NgbActiveModal,
    private router: Router
  ) {
  }

  ngOnInit(): void {
    // this.fileImg64 = this.bannerInfo ? this.bannerInfo.img : null;
    this.bannerInfo ? this.fileImg64 = this.bannerInfo.img : this.fileImg64 = null;
    this.bannerInfo ? this.fileImg64Mobile = this.bannerInfo.img2 : this.fileImg64Mobile = null;
    this.reference = this.bannerInfo.reference;
    this.dimensions = this.getImageDimensions(this.reference);
    this.dimensionsMobile = this.getImageDimensionsMobile(this.reference);
    this.createForm2();
    // this.createForm();
    if (this.router.url.includes('rent-investment') || this.router.url.includes('globalmarkets')) {
      this.isRentMax = true;
    }

    if (this.router.url.includes('rent') || this.router.url.includes('about-us')) {
      this.isRent = true;
      this.bannerForm.get('validate').value === 1 ? this.bannerForm.get('urlButton1')
        .disable() : this.bannerForm.get('urlButton1').enable();
    }
  }

  ngAfterViewInit(): void {
    this.updateForm2();
    // this.updateForm();
  }


  sendData(): any {
    const dataToSend = {
      ...this.bannerForm.value,
      reference: this.reference,
      id: this.bannerInfo.id,
    };

    // if (this.reference !== 7) {
    //   delete dataToSend.url1;
    //   delete dataToSend.url2;
    //   delete dataToSend.url3;
    //   delete dataToSend.texto1;
    //   delete dataToSend.texto2;
    //   delete dataToSend.texto3;
    // }

    // if (!this.router.url.includes('rent')) {
    //   delete dataToSend.validate;
    // }
    this.activeModal.close(dataToSend);
  }

  private createForm2(): any {
    this.bannerForm = this.fb.group({
      typeId: [0],
      img: [''],
      img64: [''],
      img64Upload: [false],
      title: [''],
      title2: [''],
      subTitle: [''],
      subTitle2: [''],
      nameButton1: [''],
      nameButton2: [''],
      urlButton1: [''],
      urlButton2: [''],
      validate: [0],
      typeIdCategoryId: [0],
      nameButton3: [''],
      nameButton4: [''],
      urlButton3: [''],
      urlButton4: [''],
      img2: [''],
      img642: [''],
      img642Upload: [false],
      img3: [''],
      img643: [''],
      img643Upload: [false],
      img4: [''],
      img644: [''],
      img644Upload: [false],
      order: [0],
      nameButton5: [''],
      urlButton5: [''],
      nameButton6: [''],
      urlButton6: [''],
      nameButton7: [''],
      urlButton7: ['']
    });
  }

  private updateForm2(): any {
    // home
    if (this.reference === 1) {
      this.bannerForm.get('title').setValue(this.bannerInfo.title);
      this.bannerForm.get('img64').setValue(this.bannerInfo.img);
      this.bannerForm.get('subTitle').setValue(this.bannerInfo.subTitle);
      this.bannerForm.get('subTitle2').setValue(this.bannerInfo.subTitle2);
      this.bannerForm.get('order').setValue(this.bannerInfo.orderId);
      this.bannerForm.get('nameButton1').setValue(this.bannerInfo.button1);
      this.bannerForm.get('urlButton1').setValue(this.bannerInfo.url1);
    }
    // fondos max 2 // New Fondos Max 14
    if (this.reference === 2 || this.reference === 14) {
      this.bannerForm.get('title').setValue(this.bannerInfo.title);
      this.bannerForm.get('title2').setValue(this.bannerInfo.title2);
      this.bannerForm.get('subTitle').setValue(this.bannerInfo.subTitle);
      this.bannerForm.get('img64').setValue(this.bannerInfo.img);
      this.bannerForm.get('order').setValue(this.bannerInfo.orderId);
      this.bannerForm.get('nameButton4').setValue(this.bannerInfo.button4);
      this.bannerForm.get('nameButton1').setValue(this.bannerInfo.button1);
      this.bannerForm.get('urlButton4').setValue(this.bannerInfo.url4);
      this.bannerForm.get('nameButton3').setValue(this.bannerInfo.button3);
      this.bannerForm.get('nameButton5').setValue(this.bannerInfo.button5);
      this.bannerForm.get('img3').setValue(this.bannerInfo.img3);
      this.bannerForm.get('urlButton5').setValue(this.bannerInfo.url5);
      this.bannerForm.get('nameButton6').setValue(this.bannerInfo.button6);
      this.bannerForm.get('urlButton6').setValue(this.bannerInfo.url6);
      this.bannerForm.get('nameButton7').setValue(this.bannerInfo.button7);
      this.bannerForm.get('urlButton7').setValue(this.bannerInfo.url7);
      this.bannerForm.get('validate').setValue(1);
    }
    if ([11, 12, 13, 15].includes(this.reference)) {
      this.bannerForm.get('title').setValue(this.bannerInfo.title);
      this.bannerForm.get('title2').setValue(this.bannerInfo.title2);
      this.bannerForm.get('subTitle').setValue(this.bannerInfo.subTitle);
      this.bannerForm.get('img64').setValue(this.bannerInfo.img);
      this.bannerForm.get('img642').setValue(this.bannerInfo.img);
      this.bannerForm.get('order').setValue(this.bannerInfo.orderId);
      this.bannerForm.get('nameButton4').setValue(this.bannerInfo.button4);
      this.bannerForm.get('nameButton1').setValue(this.bannerInfo.button1);
      this.bannerForm.get('urlButton4').setValue(this.bannerInfo.url4);
      this.bannerForm.get('nameButton3').setValue(this.bannerInfo.button3);
      // this.bannerForm.get('nameButton5').setValue(this.bannerInfo.button5);
      this.bannerForm.get('img3').setValue(this.bannerInfo.img3);
      this.bannerForm.get('urlButton5').setValue(this.bannerInfo.url5); // Only this Fact Sheet
      // this.bannerForm.get('nameButton6').setValue(this.bannerInfo.button6);
      // this.bannerForm.get('urlButton6').setValue(this.bannerInfo.url6);
      // this.bannerForm.get('nameButton7').setValue(this.bannerInfo.button7);
      // this.bannerForm.get('urlButton7').setValue(this.bannerInfo.url7);
      this.bannerForm.get('validate').setValue(1);
    }
    if ([16, 17, 18].includes(this.reference)) {
      this.maxLength = 300;
      this.bannerForm.get('title').setValue(this.bannerInfo.title);
      this.bannerForm.get('title2').setValue(this.bannerInfo.title2);
      // this.bannerForm.get('subTitle').setValue(this.bannerInfo.subTitle);
      this.bannerForm.get('img64').setValue(this.bannerInfo.img);
      this.bannerForm.get('img642').setValue(this.bannerInfo.img);
      this.bannerForm.get('order').setValue(this.bannerInfo.orderId);
      this.bannerForm.get('nameButton4').setValue(this.bannerInfo.button4);
      this.bannerForm.get('nameButton1').setValue(this.bannerInfo.button1);
      this.bannerForm.get('urlButton4').setValue(this.bannerInfo.url4);
      // this.bannerForm.get('nameButton3').setValue(this.bannerInfo.button3);
      // this.bannerForm.get('nameButton5').setValue(this.bannerInfo.button5);
      // this.bannerForm.get('img3').setValue(this.bannerInfo.img3);
      // this.bannerForm.get('urlButton5').setValue(this.bannerInfo.url5); // Only this Fact Sheet
      // this.bannerForm.get('nameButton6').setValue(this.bannerInfo.button6);
      // this.bannerForm.get('urlButton6').setValue(this.bannerInfo.url6);
      // this.bannerForm.get('nameButton7').setValue(this.bannerInfo.button7);
      // this.bannerForm.get('urlButton7').setValue(this.bannerInfo.url7);
      this.bannerForm.get('validate').setValue(1);
    }
    // nuestro respaldo
    if (this.reference === 3) {
      this.bannerForm.get('title').setValue(this.bannerInfo.title);
      this.bannerForm.get('subTitle').setValue(this.bannerInfo.subTitle);
      this.bannerForm.get('img64').setValue(this.bannerInfo.img);
      this.bannerForm.get('order').setValue(this.bannerInfo.orderId);
    }
    // renta vitalicia | renta max
    if (this.reference === 4 || this.reference === 6) {
      this.bannerForm.get('title').setValue(this.bannerInfo.title);
      this.bannerForm.get('title2').setValue(this.bannerInfo.title2);
      this.bannerForm.get('subTitle').setValue(this.bannerInfo.subTitle);
      this.bannerForm.get('img64').setValue(this.bannerInfo.img);
      this.bannerForm.get('nameButton4').setValue(this.bannerInfo.button4);
      this.bannerForm.get('urlButton4').setValue(this.bannerInfo.url4);
      this.bannerForm.get('nameButton1').setValue(this.bannerInfo.button1);
      this.bannerForm.get('urlButton1').setValue(this.bannerInfo.url1);
      this.bannerForm.get('order').setValue(this.bannerInfo.orderId);
      this.bannerForm.get('validate').setValue(1);
    }
    // nosotros
    if (this.reference === 5) {
      this.bannerForm.get('title').setValue(this.bannerInfo.title);
      this.bannerForm.get('subTitle').setValue(this.bannerInfo.subTitle);
      this.bannerForm.get('img64').setValue(this.bannerInfo.img);
      this.bannerForm.get('nameButton1').setValue(this.bannerInfo.button1);
      this.bannerForm.get('order').setValue(this.bannerInfo.orderId);
      this.bannerForm.get('validate').setValue(1);
    }
    // beneficios
    if (this.reference === 7) {
      this.bannerForm.get('title').setValue(this.bannerInfo.title);
      this.bannerForm.get('title2').setValue(this.bannerInfo.title2);
      // this.bannerForm.get('subTitle').setValue(this.bannerInfo.subTitle);
      // this.bannerForm.get('subTitle2').setValue(this.bannerInfo.subTitle2);
      this.bannerForm.get('img64').setValue(this.bannerInfo.img);
      this.bannerForm.get('nameButton1').setValue(this.bannerInfo.button1);
      this.bannerForm.get('order').setValue(this.bannerInfo.orderId);

      this.urlImgLogo = this.bannerForm.get('title2').value;
    }
    // ?????????
    // if (this.reference === 8) {
    //   this.bannerForm.get('title').setValue(this.bannerInfo.title);
    // }

    // blog
    if (this.reference === 9) {
      this.bannerForm.get('title').setValue(this.bannerInfo.title);
      this.bannerForm.get('subTitle').setValue(this.bannerInfo.subTitle);
      this.bannerForm.get('subTitle2').setValue(this.bannerInfo.subTitle2);
      this.bannerForm.get('img64').setValue(this.bannerInfo.img);
      this.bannerForm.get('nameButton1').setValue(this.bannerInfo.button1);
      this.bannerForm.get('urlButton1').setValue(this.bannerInfo.url1);
      this.bannerForm.get('order').setValue(this.bannerInfo.orderId);
    }

    // agencia virtual
    if (this.reference === 10) {
      this.bannerForm.get('title').setValue(this.bannerInfo.title);
      this.bannerForm.get('img64').setValue(this.bannerInfo.img);
      this.bannerForm.get('title2').setValue(this.bannerInfo.title2);
      this.bannerForm.get('order').setValue(this.bannerInfo.orderId);
    }
  }

  private createForm(): any {
    this.bannerForm = this.fb.group({
      title: ['', Validators.required],
      title2: [this.bannerInfo ? this.bannerInfo.title2 : ''],
      order: [null, Validators.required],
      nameButton1: [this.bannerInfo ? this.bannerInfo.button1 : '', Validators.required],
      img: [''],
      img3: [this.bannerInfo ? this.bannerInfo.img3 : ''],
      img64: [''],
      subTitle: ['', Validators.required],
      subTitle2: [''],
      nameButton3: [this.bannerInfo ? this.bannerInfo.button3 : ''],
      urlButton1: ['', Validators.required],
      nameButton5: [null],
      urlButton5: [null],
      nameButton6: [null],
      urlButton6: [null],
      nameButton7: [null],
      urlButton7: [null],
      validate: [this.bannerInfo ? this.bannerInfo.validate : 0]
    });

    if (this.reference == 7) {
      this.urlImgLogo = this.bannerForm.get('title2').value;
      const title2Control = this.bannerForm.get('title2');
      title2Control.setValidators([Validators.required]);
      title2Control.updateValueAndValidity();
      const button1Control = this.bannerForm.get('nameButton1');
      button1Control.setValidators([Validators.required]);
      button1Control.updateValueAndValidity();
      const titleControl = this.bannerForm.get('title');
      titleControl.setValidators([Validators.required]);
      titleControl.clearValidators();
      const subTitleControl = this.bannerForm.get('subTitle');
      subTitleControl.setValidators([Validators.required]);
      subTitleControl.clearValidators();
      const urlButton1Control = this.bannerForm.get('urlButton1');
      urlButton1Control.setValidators([Validators.required]);
      urlButton1Control.clearValidators();
    }
  }

  private updateForm(): any {
    this.bannerForm.get('title').setValue(this.bannerInfo.title);
    this.bannerForm.get('nameButton1').setValue(this.bannerInfo.button1);
    this.bannerForm.get('urlButton1').setValue(this.bannerInfo.url1);
    this.bannerForm.get('subTitle').setValue(this.bannerInfo.subTitle);
    this.bannerForm.get('subTitle2').setValue(this.bannerInfo.subTitle2);
    this.bannerForm.get('order').setValue(this.bannerInfo.orderId);
    this.bannerForm.get('img64').setValue(this.bannerInfo.img);
    this.bannerInfo.img64Upload = false;

    if (this.router.url.includes('rent-investment')) {
      this.bannerForm.get('nameButton5').setValue(this.bannerInfo.button5);
      this.bannerForm.get('nameButton6').setValue(this.bannerInfo.button6);
      this.bannerForm.get('nameButton7').setValue(this.bannerInfo.button7);
      this.bannerForm.get('urlButton5').setValue(this.bannerInfo.url5);
      this.bannerForm.get('urlButton6').setValue(this.bannerInfo.url6);
      this.bannerForm.get('urlButton7').setValue(this.bannerInfo.url7);
    }

    if (this.router.url.includes('rent')) {
      this.bannerForm.get('validate').setValidators([Validators.required]);
    }
  }

  getBase64(event): void {
    const reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = () => {
      const image = new Image();
      image.src = String(reader.result);
      image.onload = () => {
        if (
          ((this.reference >= 1 && this.reference <= 10 && this.reference != 6) && (image.width <= this.dimensions.width && image.height <= this.dimensions.height)) ||
          (!(this.reference >= 1 && this.reference <= 10 && this.reference != 6) && (image.width == this.dimensions.width && image.height == this.dimensions.height))
        ) {
          this.wrongSize = null;
          this.fileImg64 = image.src;
          this.bannerForm.get('img').setValue((event.target.files[0]).name);
          this.bannerForm.get('img64').setValue(this.fileImg64.split(',')[1]);
          // this.bannerForm.get('img64Upload').setValue(true);
          // this.bannerInfo.img64Upload = true;
          this.bannerForm.get('img64Upload').setValue(true);
        } else {
          this.wrongSize = `Resolución de imagen no permitida (requerida: ${this.dimensions.width}px x ${this.dimensions.height}px)`;
          return false;
        }
      };
    };
    reader.onerror = (error) => {
    };
  }

  getBase64Mobile(event): void {
    const reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = () => {
      const image = new Image();
      image.src = String(reader.result);


      image.onload = () => {
        if (image.width == this.dimensionsMobile.width && image.height == this.dimensionsMobile.height) {
          this.wrongSizeMobile = null;
          this.fileImg64Mobile = image.src;
          this.bannerForm.get('img2').setValue((event.target.files[0]).name);
          this.bannerForm.get('img642').setValue(this.fileImg64Mobile.split(',')[1]);
          // this.bannerForm.get('img642Upload').setValue(true);
          // this.bannerInfo.img642Upload = true;
          this.bannerForm.get('img642Upload').setValue(true);
        } else {
          this.wrongSizeMobile = `Resolución de imagen no permitida (requerida: ${this.dimensionsMobile.width}px x ${this.dimensionsMobile.height}px)`;
          return false;
        }
      };
    };
    reader.onerror = (error) => {
    };
  }

  title2KeyUp(event: any) {
    this.urlImgLogo = this.bannerForm.get('title2').value ? this.bannerForm.get('title2').value : 'assets/images/img-placeholder.png';
  }

  // Function to get dimensions based on ID
  getImageDimensions(id: number): ImageDimensions | undefined {
    if (id >= 1 && id <= 10 && id != 6) {
      return this.imageDimensionsMap["1-10"];
    } else if ((id >= 11 && id <= 15) || id == 6) {
      return this.imageDimensionsMap["fondos-e-inversion"];
    } else if (id >= 16 && id <= 18) {
      return this.imageDimensionsMap["rentas-vitalicias"];
    }
    return undefined; // Return undefined for IDs outside the specified ranges
  }

  getImageDimensionsMobile(id: number): ImageDimensions | undefined {
    // if (id >= 1 && id <= 10) {
    //   return this.imageDimensionsMap["1-10"];
    if ((id >= 11 && id <= 15) || id == 6) {
      return this.imageDimensionsMapMobile["fondos-e-inversion"];
    } else if (id >= 16 && id <= 18) {
      return this.imageDimensionsMapMobile["rentas-vitalicias"];
    }
    // return undefined; // Return undefined for IDs outside the specified ranges
  }
}

type ImageDimensions = {
  width: number;
  height: number;
};
